const impacts = (benzina, gasolio, benzinaDirection, gasolioDirection) => ({
  BENZINA: { label: benzina, direction: benzinaDirection },
  GASOLIO: { label: gasolio, direction: gasolioDirection },
});

export const marketEventCategories = {
  geopolitics: { label: 'Geopolitica', color: '#ba1a1a', softColor: 'rgba(186, 26, 26, .065)' },
  supply: { label: 'Offerta', color: '#006b5f', softColor: 'rgba(0, 107, 95, .065)' },
  fiscal: { label: 'Accise', color: '#755a00', softColor: 'rgba(117, 90, 0, .075)' },
  stabilization: { label: 'Stabilizzazione', color: '#285075', softColor: 'rgba(40, 80, 117, .065)' },
};

export const marketEvents = [
  {
    id: 'israel-iran-2025', start: '2025-06-13', end: '2025-06-24', title: 'Guerra Israele–Iran', shortTitle: 'Guerra Israele–Iran', category: 'geopolitics', importance: 'major',
    impacts: impacts('↑', '↑', 'up', 'up'),
    note: 'Guerra dei 12 giorni. Il Brent arrivò fino a circa 81,40 $ durante la crisi e scese rapidamente dopo il cessate il fuoco.',
    facts: ['Brent fino a ~81,40 $', 'Conflitto di 12 giorni'],
    source: { label: 'Reuters', url: 'https://www.reuters.com/world/middle-east/iranians-welcome-ceasefire-fearful-future-2025-06-24/' },
  },
  {
    id: 'opec-2025-07', start: '2025-07-05', title: 'OPEC+ accelera l’aumento della produzione', shortTitle: 'Più produzione OPEC+', category: 'supply',
    impacts: impacts('↓ pressione', '↓ pressione', 'down', 'down'),
    note: 'OPEC+ decide di aumentare la produzione di 548.000 barili al giorno da agosto, più dei precedenti incrementi mensili.',
    facts: ['+548.000 barili/giorno', 'Decorrenza: agosto 2025'],
    source: { label: 'OPEC', url: 'https://www.opec.org/pr-detail/569-05-july-2025.html' },
  },
  {
    id: 'opec-2025-08', start: '2025-08-03', title: 'Nuovo aumento della produzione OPEC+', shortTitle: 'Nuova offerta OPEC+', category: 'supply',
    impacts: impacts('↓ pressione', '↓ pressione', 'down', 'down'),
    note: 'Altri 547.000 barili al giorno da settembre 2025, completando gran parte del ritorno dell’offerta precedentemente tagliata.',
    facts: ['+547.000 barili/giorno', 'Decorrenza: settembre 2025'],
    source: { label: 'OPEC', url: 'https://www.opec.org/pr-detail/1518572-03-august-2025.html' },
  },
  {
    id: 'russia-sanctions-2025', start: '2025-10-23', title: 'Sanzioni USA contro Rosneft e Lukoil', shortTitle: 'Sanzioni sul petrolio russo', category: 'geopolitics', importance: 'major',
    impacts: impacts('↑', '↑', 'up', 'up'),
    note: 'Gli Stati Uniti colpiscono i due maggiori gruppi petroliferi russi; il petrolio reagisce con un rialzo di circa il 5%.',
    facts: ['Reazione petrolio: ~+5%', 'Rosneft e Lukoil'],
    source: { label: 'Reuters', url: 'https://www.reuters.com/world/europe/trump-sanctions-russian-oil-majors-prompting-oil-price-rise-india-jitters-2025-10-23/' },
  },
  {
    id: 'excise-alignment-2026', start: '2026-01-01', title: 'Riallineamento delle accise benzina/gasolio', shortTitle: 'Accise riallineate', category: 'fiscal', importance: 'major',
    impacts: impacts('accisa −4,05 c€/l', 'accisa +4,05 c€/l', 'down', 'up'),
    note: 'Le due accise ordinarie diventano uguali a 672,90 euro per 1.000 litri: uno scalino strutturale con segno opposto per benzina e gasolio.',
    facts: ['Aliquota: 672,90 €/1.000 l', 'Effetto opposto sui due carburanti'],
    source: { label: 'Gazzetta Ufficiale', url: 'https://www.gazzettaufficiale.it/eli/gu/2026/05/22/117/sg/pdf' },
  },
  {
    id: 'us-israel-iran-war-2026', start: '2026-02-28', ongoing: true, title: 'Guerra USA/Israele–Iran', shortTitle: 'Crisi Iran e Hormuz', category: 'geopolitics', importance: 'major',
    impacts: impacts('↑↑', '↑↑↑', 'up', 'up'),
    note: 'Grande crisi energetica del 2026, con forte riduzione del traffico attraverso Hormuz e problemi alla capacità di raffinazione. Al 25 agosto il conflitto resta irrisolto.',
    facts: ['Hormuz sotto forte pressione', 'Gasolio più esposto'],
    source: { label: 'Reuters', url: 'https://www.reuters.com/business/energy/six-months-into-iran-war-almost-half-global-oil-flows-war-zones-2026-08-25/' },
  },
  {
    id: 'iea-reserves-2026', start: '2026-03-11', title: 'Rilascio record delle riserve petrolifere IEA', shortTitle: 'Riserve IEA', category: 'stabilization', importance: 'major',
    impacts: impacts('↓ pressione', '↓ pressione', 'down', 'down'),
    note: 'Rilascio coordinato di 400 milioni di barili, di cui 172 milioni dagli Stati Uniti, per contrastare lo shock Iran/Hormuz.',
    facts: ['400 milioni di barili', '172 milioni dagli USA'],
    source: { label: 'Reuters', url: 'https://www.reuters.com/business/energy/how-have-us-presidents-tapped-strategic-petroleum-reserves-during-war-2026-03-11/' },
  },
  {
    id: 'excise-cut-phase-1', start: '2026-03-19', end: '2026-04-07', title: 'Maxi-taglio accise — fase 1', shortTitle: 'Maxi-taglio accise', category: 'fiscal', importance: 'major',
    impacts: impacts('−24,4 c€/l IVA incl.', '−24,4 c€/l IVA incl.', 'down', 'down'),
    note: 'Accisa ridotta da 672,90 a 472,90 euro per 1.000 litri per entrambi i carburanti. Il decreto stabilisce la riduzione per venti giorni.',
    facts: ['Accisa: 472,90 €/1.000 l', 'Durata prevista: 20 giorni'],
    source: { label: 'Gazzetta Ufficiale', url: 'https://www.gazzettaufficiale.it/eli/gu/2026/03/18/64/sg/pdf' },
  },
  {
    id: 'us-iran-truce-april', start: '2026-04-07', end: '2026-04-21', approximateEnd: true, title: 'Tregua USA–Iran di due settimane', shortTitle: 'Tregua USA–Iran', category: 'stabilization',
    impacts: impacts('↓ pressione', '↓ pressione', 'down', 'down'),
    note: 'Sospensione per 14 giorni dei bombardamenti statunitensi; non rappresenta la conclusione definitiva della guerra.',
    facts: ['Sospensione: 14 giorni', 'Fine indicativa: 21 aprile'],
    source: { label: 'Reuters', url: 'https://www.reuters.com/world/middle-east/trump-says-he-has-agreed-suspend-bombing-attack-iran-two-weeks-2026-04-07/' },
  },
  {
    id: 'excise-cut-extension', start: '2026-04-08', end: '2026-05-01', title: 'Maxi-taglio accise — proroga', shortTitle: 'Proroga maxi-taglio', category: 'fiscal',
    impacts: impacts('−24,4 c€/l', '−24,4 c€/l', 'down', 'down'),
    note: 'Entrambe le accise sono confermate a 472,90 euro per 1.000 litri, senza soluzione di continuità rispetto alla fase precedente.',
    facts: ['Accisa: 472,90 €/1.000 l', 'Nessuna interruzione'],
    source: { label: 'Gazzetta Ufficiale', url: 'https://www.gazzettaufficiale.it/atto/serie_generale/caricaArticoloDefault/originario?atto.codiceRedazionale=26G00061&atto.dataPubblicazioneGazzetta=2026-04-03&atto.tipoProvvedimento=DECRETO-LEGGE' },
  },
  {
    id: 'excise-differentiated', start: '2026-05-02', end: '2026-05-22', title: 'Taglio accise differenziato', shortTitle: 'Taglio differenziato', category: 'fiscal',
    impacts: impacts('−6,1 c€/l', '−24,4 c€/l', 'down', 'down'),
    note: 'La benzina passa a 622,90 euro per 1.000 litri, mentre il gasolio resta a 472,90.',
    facts: ['Benzina: 622,90 €/1.000 l', 'Gasolio: 472,90 €/1.000 l'],
    source: { label: 'Gazzetta Ufficiale', url: 'https://www.gazzettaufficiale.it/atto/serie_generale/caricaArticoloDefault/originario?atto.codiceRedazionale=26G00083&atto.dataPubblicazioneGazzetta=2026-04-30&atto.tipoProvvedimento=DECRETO-LEGGE' },
  },
  {
    id: 'diesel-discount-reduction', start: '2026-05-23', end: '2026-06-06', title: 'Riduzione dello sconto sul gasolio', shortTitle: 'Sconto gasolio ridotto', category: 'fiscal',
    impacts: impacts('−6,1 c€/l', '−12,2 c€/l', 'down', 'down'),
    note: 'Benzina a 622,90 euro per 1.000 litri; gasolio a 572,90 euro per 1.000 litri.',
    facts: ['Benzina: 622,90 €/1.000 l', 'Gasolio: 572,90 €/1.000 l'],
    source: { label: 'Gazzetta Ufficiale', url: 'https://www.gazzettaufficiale.it/atto/serie_generale/caricaArticoloDefault/originario?atto.codiceRedazionale=26A03280&atto.dataPubblicazioneGazzetta=2026-06-27&atto.tipoProvvedimento=TESTO+COORDINATO+DEL+DECRETO-LEGGE' },
  },
  {
    id: 'last-general-excise-cut', start: '2026-06-07', end: '2026-07-03', title: 'Ultima fase del taglio generale delle accise', shortTitle: 'Ultima fase accise', category: 'fiscal',
    impacts: impacts('−6,1 c€/l', '−6,1 c€/l', 'down', 'down'),
    note: 'Entrambi i carburanti sono a 622,90 euro per 1.000 litri, rispetto all’aliquota ordinaria di 672,90.',
    facts: ['Entrambi: 622,90 €/1.000 l', 'Sconto accisa: 5 c€/l'],
    source: { label: 'Gazzetta Ufficiale', url: 'https://www.gazzettaufficiale.it/atto/serie_generale/caricaArticoloDefault/originario?atto.codiceRedazionale=26A03280&atto.dataPubblicazioneGazzetta=2026-06-27&atto.tipoProvvedimento=TESTO+COORDINATO+DEL+DECRETO-LEGGE' },
  },
  {
    id: 'us-iran-truce-june', start: '2026-06-15', end: '2026-08-18', title: 'Accordo/tregua USA–Iran', shortTitle: 'Accordo USA–Iran', category: 'stabilization', importance: 'major',
    impacts: impacts('↓', '↓', 'down', 'down'),
    note: 'Accordo preliminare per una tregua e per riaprire Hormuz. L’annuncio provocò una forte discesa del petrolio; il cessate il fuoco è poi scaduto senza un accordo definitivo.',
    facts: ['Tregua fragile', 'Riapertura di Hormuz'],
    source: { label: 'Reuters', url: 'https://www.reuters.com/world/asia-pacific/iran-us-agree-halt-war-reopen-hormuz-sending-oil-prices-tumbling-2026-06-15/' },
  },
  {
    id: 'general-excise-cut-end', start: '2026-07-04', end: '2026-07-29', title: 'Fine del taglio generale delle accise', shortTitle: 'Accise ordinarie', category: 'fiscal',
    impacts: impacts('672,90 €/1.000 l', '672,90 €/1.000 l', 'up', 'up'),
    note: 'Benzina e gasolio tornano temporaneamente entrambi all’aliquota ordinaria.',
    facts: ['Aliquota ordinaria ripristinata', 'Entrambi: 672,90 €/1.000 l'],
    source: { label: 'Gazzetta Ufficiale', url: 'https://www.gazzettaufficiale.it/atto/serie_generale/caricaArticoloDefault/originario?atto.codiceRedazionale=26A03280&atto.dataPubblicazioneGazzetta=2026-06-27&atto.tipoProvvedimento=TESTO+COORDINATO+DEL+DECRETO-LEGGE' },
  },
  {
    id: 'opec-2026-07', start: '2026-07-05', title: 'OPEC+ aumenta nuovamente la produzione', shortTitle: 'Aumento OPEC+', category: 'supply',
    impacts: impacts('↓ pressione', '↓ pressione', 'down', 'down'),
    note: 'Aumento di 188.000 barili al giorno da agosto 2026.',
    facts: ['+188.000 barili/giorno', 'Decorrenza: agosto 2026'],
    source: { label: 'OPEC', url: 'https://www.opec.org/pr-detail/609-5-july-2026.html' },
  },
  {
    id: 'diesel-only-excise-cut', start: '2026-07-30', end: '2026-08-26', title: 'Nuovo taglio dell’accisa solo sul gasolio', shortTitle: 'Taglio solo gasolio', category: 'fiscal', importance: 'major',
    impacts: impacts('nessun taglio', '−14 c€/l accisa', 'neutral', 'down'),
    note: 'Gasolio da 672,90 a 532,90 euro per 1.000 litri, pari a circa −17,1 centesimi al litro considerando l’IVA. Prorogato fino al 26 agosto.',
    facts: ['Gasolio: 532,90 €/1.000 l', 'Con IVA: circa −17,1 c€/l'],
    source: { label: 'Gazzetta Ufficiale', url: 'https://www.gazzettaufficiale.it/atto/serie_generale/caricaArticoloDefault/originario?atto.codiceRedazionale=26G00155&atto.dataPubblicazioneGazzetta=2026-07-27&atto.tipoProvvedimento=DECRETO-LEGGE' },
  },
  {
    id: 'opec-2026-08', start: '2026-08-02', title: 'OPEC+ annuncia un altro aumento per settembre', shortTitle: 'Nuova offerta OPEC+', category: 'supply',
    impacts: impacts('↓ pressione', '↓ pressione', 'down', 'down'),
    note: 'Ulteriore aumento di 188.000 barili al giorno da settembre 2026.',
    facts: ['+188.000 barili/giorno', 'Decorrenza: settembre 2026'],
    source: { label: 'OPEC', url: 'https://www.opec.org/pr-detail/611-2-august-2026.html' },
  },
  {
    id: 'us-iran-truce-expiry', start: '2026-08-18', title: 'Scadenza della tregua USA–Iran', shortTitle: 'Tregua scaduta', category: 'geopolitics', importance: 'major',
    impacts: impacts('↑ rischio', '↑ rischio', 'up', 'up'),
    note: 'La tregua scade senza un nuovo accordo; rimangono tensioni su Hormuz e rischio di una nuova escalation.',
    facts: ['Nessun accordo definitivo', 'Rischio Hormuz'],
    source: { label: 'Reuters', url: 'https://www.reuters.com/podcasts/us-iran-ceasefire-expires-tupac-murder-trial-microdramas-2026-08-18/' },
  },
  {
    id: 'iran-sanctions-2026-08', start: '2026-08-25', title: 'Nuove sanzioni USA contro l’Iran', shortTitle: 'Nuove sanzioni Iran', category: 'geopolitics',
    impacts: impacts('volatilità', 'volatilità', 'mixed', 'mixed'),
    note: 'Nuove sanzioni economiche. Il petrolio reagisce inizialmente al ribasso, con Brent intorno a 88 dollari al barile, perché il mercato le considera meno severe del temuto.',
    facts: ['Brent intorno a 88 $/barile', 'Reazione iniziale al ribasso'],
    source: { label: 'Reuters', url: 'https://www.reuters.com/business/energy/oil-prices-steady-investors-weigh-impact-expanded-us-sanctions-against-iran-2026-08-25/' },
  },
];

export function getMarketEventsInRange(dates = [], fuels = ['BENZINA', 'GASOLIO']) {
  if (!dates.length) return [];
  const first = dates[0];
  const last = dates[dates.length - 1];
  const requestedFuels = Array.isArray(fuels) ? fuels : [fuels];
  if (!requestedFuels.some(fuel => fuel === 'BENZINA' || fuel === 'GASOLIO')) return [];

  return marketEvents.filter(event => {
    const eventEnd = event.end || (event.ongoing ? last : event.start);
    return event.start <= last && eventEnd >= first;
  });
}
